import { Flex, Space, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Bone from "../../../../Components/Skeleton/Bone"

import styles from "./countriesPanel.module.less"

const { Text } = Typography

// Bar lengths of the top ten, as a share of the longest.
const BARS = [100, 78, 62, 52, 44, 38, 30, 24, 18, 12]
const X_TICKS = 6

// CardTotalPanel's frame (real labels, the figures as bars) over CountryChart's: a flag, a
// name and a 22px bar per country inside its 360px, and the count ticks under them.
const CountriesPanelSkeleton = () => {
  const { t } = useTranslation()
  const isMobile = useSelector((s) => s.nav.isMobile)

  return (
    <>
      {/* No gap under the totals on a phone, as in CountriesPanel. */}
      <Flex gap={40} style={{ marginBottom: isMobile ? 0 : 32 }}>
        {[t("Count"), t("Volume")].map((label, i) => (
          <Space key={label} direction="vertical" size={7}>
            <Text style={{ fontSize: 14, lineHeight: "20px" }} type="secondary">
              {label}
            </Text>
            <span className={isMobile ? styles.skeletonFigureMobile : styles.skeletonFigure}>
              <Bone width={i ? 112 : 64} height={isMobile ? 16 : 22} />
            </span>
          </Space>
        ))}
      </Flex>
      <div className={`${styles.chart} ${styles.skeletonChart}`}>
        {BARS.map((share, i) => (
          <div key={i} className={styles.skeletonRow}>
            <span className={styles.skeletonLabel}>
              <Bone width={20} height={15} />
              <Bone width={88} height={14} />
            </span>
            <span className={styles.skeletonBar}>
              <Bone width={`${share}%`} height={22} radius={2} />
            </span>
          </div>
        ))}
        <div className={styles.skeletonAxis}>
          {Array.from({ length: X_TICKS }, (_, i) => (
            <Bone key={i} width={24} height={10} />
          ))}
        </div>
      </div>
    </>
  )
}

export default CountriesPanelSkeleton
